import React, { createRef, useState } from "react";

import { useSetRecoilState } from "recoil";
import {
  customToastState,
  errorToastState,
  modalState,
} from "lib/store/common";
import { requestCategory } from "lib/store/project";

import { Button, ButtonLike } from "@atsent/components";

import "./RequestCategoryTab.scss";

export type RequestCategoryTabProps = {
  cx?: string;
};

export const RequestCategoryTab: React.FC<RequestCategoryTabProps> = ({
  cx = "",
}) => {
  const setModal = useSetRecoilState(modalState);
  const setErrorToast = useSetRecoilState(errorToastState);

  const setToast = useSetRecoilState(customToastState);
  const [request, setRequest] = useState({ name: "", description: "" });

  const inputRef = createRef<HTMLInputElement>();
  const textareaRef = createRef<HTMLTextAreaElement>();

  return (
    <div className={`RequestCategoryTab ${cx}`}>
      <div className="main-contents">
        <span>카테고리명</span>
        <input
          type="text"
          placeholder={"원하는 분야 카테고리를 입력해주세요."}
          ref={inputRef}
          onChange={(e) => setRequest((_) => ({ ..._, name: e.target.value }))}
        />
        <span>부연 설명</span>
        <textarea
          name="ta"
          placeholder={"해당 카테고리에 대한 설명을 입력해주세요."}
          ref={textareaRef}
          onChange={(e) =>
            setRequest((_) => ({ ..._, description: e.target.value }))
          }
        />
        <div className="bottom">
          <p>
            상담이 필요하신 경우, 부연 설명란에 이메일 주소를 남겨주시거나
            <br />
            채널톡으로 문의주시면 답변 드리도록 하겠습니다.
          </p>
          <ButtonLike cx={"center small"} outline>
            채널톡 상담
          </ButtonLike>
        </div>
      </div>
      <div className="button-wrapper">
        <span
          className={"small"}
          onClick={() =>
            setModal((_) => ({
              ..._,
              requestCategory: false,
              categorySelect: true,
            }))
          }
        >
          ← 카테고리 선택창으로 돌아가기
        </span>
        <Button
          click={async () => {
            console.log(inputRef.current);
            if (
              !inputRef.current ||
              !textareaRef.current ||
              inputRef.current.value.length === 0 ||
              textareaRef.current.value.length === 0
            ) {
              setToast({
                type: "error",
                text: "모든 필드를 입력 해 주세요",
              });
              return;
            }
            inputRef.current.value = "";
            textareaRef.current.value = "";
            try {
              await requestCategory(request);
              await setToast({
                type: "success",
                text: "신청이 완료되었습니다.",
              });
              await setRequest({ name: "", description: "" });
            } catch (e) {
              setErrorToast(e);
            }
          }}
          isNext
        >
          요청 보내기
        </Button>
      </div>
    </div>
  );
};
